import { rest } from 'msw';
import mockPLCColmNg from './resolvers/mockPLCColmNg';

const handlers = [
  rest.get('api/PLCColmNg', (req, res, ctx) => {
    // Check if the user is authenticated in this session
    console.debug('api/PLCColmNg======');
    const isAuthenticated = sessionStorage.getItem('is-authenticated');
    if (!isAuthenticated) {
      // If not authenticated, respond with a 403 error
      console.debug('api/PLCColmNg======');
      return res(
        ctx.status(403),
        ctx.json({
          errorMessage: 'Not authorized',
        })
      );
    }
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        username: 'admin',
      })
    );
  }),
];

export default handlers;
